import React from 'react';
import { Box } from '@chakra-ui/react';
import ReactJWPlayer from 'react-jw-player';
import dynamic from 'next/dynamic';

const VideoNft = ({ file, type }) => {
  return (
    <Box className="jw-video-container" style={{ height: '100%', width: '100%' }}>
      <ReactJWPlayer
        playerId="q3UukveW"
        playerScript="https://content.jwplatform.com/libraries/q3UukveW.js"
        playlist={[
          {
            sources: [
              {
                default: false,
                type: type || 'hls',
                file,
                label: '0',
              },
            ],
          },
        ]}
        primary="html5"
        hlshtml={true}
      />
    </Box>
  );
};
export default VideoNft;
